angular.module('bizmetryApp')
  .controller('EnvironmentMappingsController', [
    '$scope',
    '$mdDialog',
    '$mdToast',
    '$timeout',
    'resource',
    'profile',
    'accountId',
    'DatasourceService',
    'dialogService',
    'template',

    function ($scope, $mdDialog, $mdToast, $timeout, resource, profile, accountId, DatasourceService, dialogService,
      template
    ) {

      // ============================================
      // TRANSIENT UI KEYS — never persisted
      // ============================================

      var TRANSIENT_KEYS = [
        'isEditing', 'markedForDeletion', 'originalValues',
        'availableSchemas', 'availableTables', 'loadingSchemas',
        'loadingTables', 'tableSearchText', 'queryTables',
        'validatingTable', 'isOnline'
      ];

      function cleanMappings(mappings) {
        (mappings || []).forEach(function (mapping) {
          TRANSIENT_KEYS.forEach(function (key) { delete mapping[key]; });
        });
      }

      // ============================================
      // INITIALIZATION
      // ============================================

      $scope.resource = resource;
      $scope.profile = profile;
      $scope.accountId = accountId;
      $scope.template = template;

      $scope.originalResource = angular.copy(resource);

      $scope.isAddingMapping = false;
      $scope.hasUnsavedChanges = false;

      console.log('**** ResourceType=', $scope.resource);
      console.log('**** template=', $scope.template);
      console.log('**** originalResource=', $scope.originalResource);

      if (!$scope.resource.env_mappings) {
        $scope.resource.env_mappings = [];
      }

      if (!$scope.originalResource.env_mappings) {
        $scope.originalResource.env_mappings = [];
      }

      $scope.availableEnvironments = profile.environments || [];
      $scope.newMapping = {};
      $scope.schemas = [];
      $scope.tables = [];
      $scope.loadingSchemas = false;
      $scope.loadingTables = false;
      $scope.tableSearchText = '';
      $scope.datasources = [];
      $scope.loading = true;

      loadDatasources();

      // ============================================
      // LOAD DATASOURCES
      // ============================================

      function loadDatasources() {
        DatasourceService.getDatasources(accountId)
          .then(function (datasources) {
            $scope.datasources = datasources;
            $scope.loading = false;
          })
          .catch(function (error) {
            console.error('Error loading datasources:', error);
            showToast('Error loading datasources');
            $scope.datasources = [];
            $scope.loading = false;
          });
      }

      // ============================================
      // SHARED: LOAD SCHEMAS & TABLES
      // ============================================

      function loadSchemas(datasourceId, target, schemasKey, loadingKey) {
        if (!datasourceId) {
          console.warn('No datasource selected');
          return;
        }

        console.log('Loading schemas for datasource:', datasourceId);
        target[loadingKey] = true;
        target[schemasKey] = [];

        DatasourceService.getSchemas(datasourceId)
          .then(function (response) {
            console.log('Schemas response:', response);

            if (Array.isArray(response)) {
              target[schemasKey] = response;
            } else if (response.data && Array.isArray(response.data)) {
              target[schemasKey] = response.data;
            } else {
              console.error('Unexpected response structure:', response);
              target[schemasKey] = [];
              showToast('Invalid response format for schemas');
            }

            console.log('Loaded schemas:', target[schemasKey].length);
            target[loadingKey] = false;
            safeApply();
          })
          .catch(function (error) {
            console.error('Error loading schemas:', error);
            showToast('Error loading schemas: ' + getErrorMessage(error));
            target[schemasKey] = [];
            target[loadingKey] = false;
            safeApply();
          });
      }

      function loadTables(datasourceId, schemaName, target, tablesKey, loadingKey) {
        if (!datasourceId || !schemaName) {
          console.warn('Datasource or schema not selected');
          return;
        }

        console.log('Loading tables for datasource:', datasourceId, 'schema:', schemaName);
        target[loadingKey] = true;
        target[tablesKey] = [];

        DatasourceService.getEntities(datasourceId, schemaName)
          .then(function (response) {
            console.log('Tables response:', response);

            var tableData = Array.isArray(response) ? response :
              (response.data && Array.isArray(response.data) ? response.data : []);

            if (tableData.length > 0) {
              target[tablesKey] = tableData.map(function (table) {
                return table.tableName || table;
              });
              console.log('Loaded tables:', target[tablesKey].length);
            } else {
              console.warn('No tables found');
              target[tablesKey] = [];
            }

            target[loadingKey] = false;
            safeApply();
          })
          .catch(function (error) {
            console.error('Error loading tables:', error);
            showToast('Error loading tables: ' + getErrorMessage(error));
            target[tablesKey] = [];
            target[loadingKey] = false;
            safeApply();
          });
      }

      function queryTables(tables, searchText) {
        if (!tables || tables.length === 0) return [];
        if (!searchText) return tables;
        var lowercaseQuery = searchText.toLowerCase();
        return tables.filter(function (table) {
          return table.toLowerCase().indexOf(lowercaseQuery) !== -1;
        });
      }

      // ============================================
      // VALIDATION HELPERS
      // ============================================

      function getExpectedColumns(resourceId) {
        if (!$scope.template || !$scope.template.templateConfig.attribute_types) return [];
        return $scope.template.templateConfig.attribute_types
          .filter(function (attr) {
            return attr.resource_id === resourceId && attr.column_metadata_name;
          })
          .map(function (attr) {
            return { name: attr.column_metadata_name, attributeId: attr.id, attributeName: attr.name };
          });
      }

      function validateTableStructure(datasourceId, schemaName, tableName, expectedColumns) {
        console.log('Validating table structure...');
        console.log('Expected columns:', expectedColumns);

        return DatasourceService.getAttributes(datasourceId, schemaName, tableName)
          .then(function (actualColumns) {
            console.log('Actual columns from database:', actualColumns);

            var missingColumns = [];
            var foundColumns = [];

            expectedColumns.forEach(function (expected) {
              var actualCol = actualColumns.find(function (col) {
                return col.columnName.toLowerCase() === expected.name.toLowerCase();
              });
              if (!actualCol) {
                missingColumns.push({ columnName: expected.name, attributeName: expected.attributeName });
              } else {
                foundColumns.push(expected.name);
              }
            });

            var isValid = missingColumns.length === 0;

            return {
              isValid: isValid,
              missingColumns: missingColumns,
              foundColumns: foundColumns,
              summary: {
                expectedColumns: expectedColumns.length,
                actualColumns: actualColumns.length,
                matchedColumns: foundColumns.length,
                missingColumns: missingColumns.length
              }
            };
          })
          .catch(function (error) {
            console.error('Error validating table structure:', error);
            return {
              isValid: false,
              error: 'Failed to retrieve table structure: ' + getErrorMessage(error),
              missingColumns: [],
              foundColumns: [],
              summary: null
            };
          });
      }

      function showValidationErrorDialog(validationResult) {
        var message = 'The selected table structure does not match the expected metadata for this imported resource. ';
        message += 'Please select a different table that matches the expected structure.';
        return dialogService.showErrorDialog('Table Validation Failed', message);
      }

      // ============================================
      // ADD NEW MAPPING (WITH VALIDATION)
      // ============================================

      $scope.addNewMapping = function () {
        if ($scope.isAddMappingDisabled()) return;

        $scope.isAddingMapping = true;
        $scope.newMapping = {
          env_id: null,
          datasource_id: null,
          schema_name: null,
          table_name: null
        };
        $scope.schemas = [];
        $scope.tables = [];
        $scope.tableSearchText = '';
      };

      $scope.saveNewMapping = function () {
        console.log('=== SAVE NEW MAPPING CALLED ===');

        if (!$scope.isNewMappingValid()) {
          console.log('❌ Mapping is not valid');
          return;
        }

        console.log('✅ Mapping is valid');

        if ($scope.resource.is_resource_imported === true) {
          console.log('✅ ENTERING VALIDATION BLOCK');

          var expectedColumns = getExpectedColumns($scope.resource.id);
          console.log('Expected columns found:', expectedColumns.length);

          if (expectedColumns.length === 0) {
            console.warn('⚠️ No expected columns found for resource:', $scope.resource.id);
            showToast('Warning: No column metadata found for this resource');
            completeSaveNewMapping();
            return;
          }

          $scope.validatingTable = true;

          validateTableStructure(
            $scope.newMapping.datasource_id,
            $scope.newMapping.schema_name,
            $scope.newMapping.table_name,
            expectedColumns
          ).then(function (validationResult) {
            $scope.validatingTable = false;
            console.log('Validation result:', validationResult);

            if (!validationResult.isValid) {
              console.log('❌ Validation FAILED - showing error dialog');
              showValidationErrorDialog(validationResult);
              return;
            }

            console.log('✅ Validation PASSED');
            completeSaveNewMapping();
            showToast('Table structure validated successfully');
          }).catch(function (error) {
            console.error('❌ Validation promise rejected:', error);
            $scope.validatingTable = false;
            dialogService.showErrorDialog(
              'Validation Error',
              'Failed to validate table structure: ' + getErrorMessage(error)
            );
          });
        } else {
          console.log('⚠️ Resource is NOT imported, skipping validation');
          completeSaveNewMapping();
        }
      };

      function completeSaveNewMapping() {
        var selectedEnv = findById($scope.availableEnvironments, $scope.newMapping.env_id);
        var selectedDs = findById($scope.getFilteredDatasources($scope.newMapping.env_id), $scope.newMapping.datasource_id);

        // El primer mapping siempre es master; los siguientes nunca lo son al crearse
        var isFirstMapping = $scope.resource.env_mappings.length === 0;

        var newMappingToAdd = {
          env_id: $scope.newMapping.env_id,
          env_name: selectedEnv ? selectedEnv.name : '',
          datasource_id: $scope.newMapping.datasource_id,
          datasource_name: selectedDs ? selectedDs.datasourceName : '',
          schema_name: $scope.newMapping.schema_name,
          table_name: $scope.newMapping.table_name,
          is_master: isFirstMapping
        };

        $scope.resource.env_mappings.push(newMappingToAdd);
        $scope.isAddingMapping = false;
        $scope.hasUnsavedChanges = true;

        $scope.newMapping = {};
        $scope.schemas = [];
        $scope.tables = [];

        showToast('Mapping added successfully');
      }

      $scope.cancelNewMapping = function () {
        $scope.isAddingMapping = false;
        $scope.newMapping = {};
        $scope.schemas = [];
        $scope.tables = [];
        $scope.tableSearchText = '';
      };

      $scope.isNewMappingValid = function () {
        return $scope.newMapping.env_id &&
          $scope.newMapping.datasource_id &&
          $scope.newMapping.schema_name &&
          $scope.newMapping.table_name;
      };

      // ============================================
      // EDIT EXISTING MAPPING (WITH VALIDATION)
      // ============================================

      $scope.editMapping = function (mapping, $event) {
        if ($event) $event.stopPropagation();

        mapping.originalValues = {
          env_id: mapping.env_id,
          datasource_id: mapping.datasource_id,
          schema_name: mapping.schema_name,
          table_name: mapping.table_name
        };

        mapping.isEditing = true;
        mapping.loadingSchemas = false;
        mapping.loadingTables = false;
        mapping.availableSchemas = [];
        mapping.availableTables = [];
        mapping.tableSearchText = mapping.table_name || '';

        mapping.queryTables = function (searchText) {
          return queryTables(mapping.availableTables, searchText);
        };

        loadSchemas(mapping.datasource_id, mapping, 'availableSchemas', 'loadingSchemas');

        if (mapping.schema_name) {
          loadTables(mapping.datasource_id, mapping.schema_name, mapping, 'availableTables', 'loadingTables');
        }
      };

      $scope.saveEditMapping = function (mapping) {
        if (!isEditMappingValid(mapping)) return;

        if ($scope.resource.is_resource_imported === true) {
          console.log('Resource is imported, validating table structure...');

          var expectedColumns = getExpectedColumns($scope.resource.id);

          if (expectedColumns.length === 0) {
            console.warn('No expected columns found for resource:', $scope.resource.id);
            showToast('Warning: No column metadata found for this resource');
            completeSaveEditMapping(mapping);
            return;
          }

          mapping.validatingTable = true;

          validateTableStructure(
            mapping.datasource_id,
            mapping.schema_name,
            mapping.table_name,
            expectedColumns
          ).then(function (validationResult) {
            mapping.validatingTable = false;
            console.log('Validation result:', validationResult);

            if (!validationResult.isValid) {
              showValidationErrorDialog(validationResult);
              return;
            }

            completeSaveEditMapping(mapping);
            showToast('Table structure validated successfully');
          }).catch(function (error) {
            console.error('Validation error:', error);
            mapping.validatingTable = false;
            dialogService.showErrorDialog(
              'Validation Error',
              'Failed to validate table structure: ' + getErrorMessage(error)
            );
          });
        } else {
          completeSaveEditMapping(mapping);
        }
      };

      function completeSaveEditMapping(mapping) {
        var selectedEnv = findById($scope.availableEnvironments, mapping.env_id);
        var selectedDs = findById($scope.getFilteredDatasources(mapping.env_id), mapping.datasource_id);

        mapping.env_name = selectedEnv ? selectedEnv.name : mapping.env_name;
        mapping.datasource_name = selectedDs ? selectedDs.datasourceName : mapping.datasource_name;

        // Limpiar propiedades UI transitorias
        TRANSIENT_KEYS.forEach(function (key) { delete mapping[key]; });

        $scope.hasUnsavedChanges = true;
        showToast('Mapping updated successfully');
      }

      $scope.cancelEditMapping = function (mapping) {
        if (mapping.originalValues) {
          mapping.env_id = mapping.originalValues.env_id;
          mapping.datasource_id = mapping.originalValues.datasource_id;
          mapping.schema_name = mapping.originalValues.schema_name;
          mapping.table_name = mapping.originalValues.table_name;
        }

        // Limpiar propiedades UI transitorias
        TRANSIENT_KEYS.forEach(function (key) { delete mapping[key]; });
      };

      function isEditMappingValid(mapping) {
        return mapping.env_id &&
          mapping.datasource_id &&
          mapping.schema_name &&
          mapping.table_name;
      }

      // ============================================
      // DELETE MAPPING
      // ============================================

      $scope.markOrDeleteMapping = function (mapping, $event) {
        if ($event) $event.stopPropagation();

        if (mapping.markedForDeletion) {
          if (mapping.is_master === true) {
            console.log('⚠️ Attempting to delete MASTER mapping:', mapping.env_name);

            dialogService.showDecisionDialog(
              'Delete Master Mapping?',
              'If you proceed, the resource will be unlinked from the datasource, and you\'ll need to link it again. Are you sure you want to continue?'
            ).then(function (decision) {
              if (decision === 'proceed') {
                console.log('✅ User confirmed deletion of master mapping');
                deleteMappingAndUnlinkResource(mapping);

                // Limpiar antes de cerrar
                cleanMappings($scope.resource.env_mappings);
                $mdDialog.hide($scope.resource);
              } else {
                console.log('❌ User cancelled deletion of master mapping');
                mapping.markedForDeletion = false;
              }
            });

          } else {
            console.log('🗑️ Deleting non-master mapping:', mapping.env_name);
            deleteMappingNormal(mapping);
          }

        } else {
          mapping.markedForDeletion = true;

          $timeout(function () {
            mapping.markedForDeletion = false;
          }, 3000);
        }
      };

      function deleteMappingAndUnlinkResource(mapping) {
        var index = $scope.resource.env_mappings.indexOf(mapping);

        if (index > -1) {
          console.log('🗑️ Deleting master mapping and unlinking resource (all env mappings will be removed)...');

          // ✅ FIX: Eliminar TODOS los env_mappings, no solo el master
          $scope.resource.env_mappings.splice(0, $scope.resource.env_mappings.length);
          $scope.resource.is_resource_imported = false;

          console.log('✅ All env mappings deleted');
          console.log('✅ is_resource_imported set to FALSE');

          if ($scope.template && $scope.template.templateConfig && $scope.template.templateConfig.attribute_types) {
            var attributesCleared = 0;
            $scope.template.templateConfig.attribute_types.forEach(function (attr) {
              if (attr.resource_id === $scope.resource.id && attr.column_metadata_name) {
                console.log('  🧹 Clearing column_metadata_name: "' + attr.name + '" (was: "' + attr.column_metadata_name + '")');
                attr.column_metadata_name = null;
                attributesCleared++;
              }
            });
            console.log('✅ Cleared column_metadata_name from ' + attributesCleared + ' attribute(s)');
          }

          showToast('Master mapping deleted. All environment mappings removed and resource unlinked from datasource');

          $scope.hasUnsavedChanges = true;
        }
      }
      function deleteMappingNormal(mapping) {
        var index = $scope.resource.env_mappings.indexOf(mapping);

        if (index > -1) {
          $scope.resource.env_mappings.splice(index, 1);
          $scope.hasUnsavedChanges = true;
          console.log('✅ Non-master mapping deleted:', mapping.env_name);
          showToast('Mapping deleted successfully');
        }
      }

      // ============================================
      // CHANGE HANDLERS
      // ============================================

      $scope.onEnvironmentChange = function () {
        $scope.newMapping.datasource_id = null;
        $scope.newMapping.schema_name = null;
        $scope.newMapping.table_name = null;
        $scope.schemas = [];
        $scope.tables = [];
      };

      $scope.onDatasourceChange = function () {
        $scope.newMapping.schema_name = null;
        $scope.newMapping.table_name = null;
        $scope.tables = [];
        if ($scope.newMapping.datasource_id) {
          loadSchemas($scope.newMapping.datasource_id, $scope, 'schemas', 'loadingSchemas');
        }
      };

      $scope.onSchemaChange = function () {
        $scope.newMapping.table_name = null;
        if ($scope.newMapping.schema_name) {
          loadTables($scope.newMapping.datasource_id, $scope.newMapping.schema_name, $scope, 'tables', 'loadingTables');
        }
      };

      $scope.onEditEnvironmentChange = function (mapping) {
        mapping.datasource_id = null;
        mapping.schema_name = null;
        mapping.table_name = null;
        mapping.availableSchemas = [];
        mapping.availableTables = [];
      };

      $scope.onEditDatasourceChange = function (mapping) {
        mapping.schema_name = null;
        mapping.table_name = null;
        mapping.availableTables = [];
        if (mapping.datasource_id) {
          loadSchemas(mapping.datasource_id, mapping, 'availableSchemas', 'loadingSchemas');
        }
      };

      $scope.onEditSchemaChange = function (mapping) {
        mapping.table_name = null;
        if (mapping.schema_name) {
          loadTables(mapping.datasource_id, mapping.schema_name, mapping, 'availableTables', 'loadingTables');
        }
      };

      // ============================================
      // QUERY TABLES (for autocomplete)
      // ============================================

      $scope.queryTables = function (searchText) {
        return queryTables($scope.tables, searchText);
      };

      // ============================================
      // DATASOURCE FILTERING
      // ============================================

      $scope.getFilteredDatasources = function (envId) {
        if (!envId || !$scope.datasources) return [];
        return $scope.datasources.filter(function (ds) {
          return ds.environmentTypeId === envId;
        });
      };

      $scope.hasAvailableDatasources = function () {
        if (!$scope.newMapping.env_id) return false;
        var datasources = $scope.getFilteredDatasources($scope.newMapping.env_id);
        return datasources && datasources.length > 0;
      };

      // ============================================
      // ENVIRONMENT AVAILABILITY
      // ============================================

      $scope.getAvailableEnvironmentsForNew = function () {
        if (!$scope.availableEnvironments) return [];
        var mappedEnvIds = $scope.resource.env_mappings.map(function (m) { return m.env_id; });
        return $scope.availableEnvironments.filter(function (env) {
          return mappedEnvIds.indexOf(env.id) === -1;
        });
      };

      $scope.isAddMappingDisabled = function () {
        if ($scope.isAddingMapping) return true;
        if ($scope.resource.env_mappings && $scope.resource.env_mappings.some(function (m) { return m.isEditing; })) return true;
        if ($scope.datasources.length === 0) return true;
        var availableEnvs = $scope.getAvailableEnvironmentsForNew();
        return !availableEnvs || availableEnvs.length === 0;
      };

      // ============================================
      // CHANGE DETECTION
      // ============================================

      $scope.hasChanges = function () {
        if ($scope.isAddingMapping) return false;
        if ($scope.resource.env_mappings && $scope.resource.env_mappings.some(function (m) { return m.isEditing; })) return false;
        if (!$scope.hasUnsavedChanges) return hasStructuralChanges();
        return $scope.hasUnsavedChanges;
      };

      function hasStructuralChanges() {
        var currentMappings = $scope.resource.env_mappings || [];
        var originalMappings = $scope.originalResource.env_mappings || [];

        if (currentMappings.length !== originalMappings.length) return true;
        if (currentMappings.length === 0) return false;

        for (var i = 0; i < currentMappings.length; i++) {
          var current = currentMappings[i];
          var original = originalMappings[i];
          if (!original) return true;
          if (current.env_id !== original.env_id ||
            current.datasource_id !== original.datasource_id ||
            current.schema_name !== original.schema_name ||
            current.table_name !== original.table_name ||
            current.is_master !== original.is_master) {
            return true;
          }
        }

        return false;
      }

      // ============================================
      // DIALOG ACTIONS
      // ============================================

      $scope.save = function () {
        var isValid = true;

        if ($scope.resource.env_mappings) {
          isValid = $scope.resource.env_mappings.every(function (mapping) {
            return mapping.env_id &&
              mapping.datasource_id &&
              mapping.schema_name &&
              mapping.table_name;
          });
        }

        if (!isValid) {
          $mdDialog.show(
            $mdDialog.alert()
              .title('Invalid Mappings')
              .textContent('Please complete all mapping fields before saving.')
              .ok('OK')
          );
          return;
        }

        // Limpiar propiedades UI transitorias antes de persistir
        cleanMappings($scope.resource.env_mappings);

        $scope.hasUnsavedChanges = false;
        $mdDialog.hide($scope.resource);
      };

      $scope.cancel = function () {
        if ($scope.hasUnsavedChanges) {
          dialogService.showDecisionDialog(
            'Discard Changes?',
            'You have unsaved changes. Are you sure you want to discard them?'
          ).then(function (decision) {
            if (decision === 'proceed') {
              $mdDialog.hide($scope.originalResource);
            }
          });
        } else {
          $mdDialog.hide($scope.originalResource);
        }
      };

      // ============================================
      // UTILITY FUNCTIONS
      // ============================================

      function findById(array, id) {
        return array.find(function (item) { return item.id === id; });
      }

      function showToast(message) {
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .position('top right')
            .hideDelay(3000)
        );
      }

      function getErrorMessage(error) {
        return (error.data && error.data.message) || error.message || 'Unknown error';
      }

      function safeApply() {
        $timeout(function () {
          if (!$scope.$$phase) $scope.$apply();
        }, 0);
      }

    }
  ]);